var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 1600 1200" },
      attrs: {
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0",
        y: "0",
        viewBox: "100 100 1400 1000",
        "xml:space": "preserve",
      },
    },
    [
      _c(
        "g",
        { attrs: { transform: "matrix(1.79125 0 0 1.79167 70 40)" } },
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_1_",
                gradientUnits: "userSpaceOnUse",
                x1: "-43.775",
                y1: "318.044",
                x2: "693.96",
                y2: "318.044",
                gradientTransform:
                  "matrix(1.7912 0 0 -1.7917 140.677 1133.488)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: "0" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("path", {
            staticStyle: {
              opacity: ".6",
              fill: "url(#SVGID_1_)",
              "enable-background": "new",
            },
            attrs: { d: "M800 600c-258.6-97.8-504.3-96.1-737.7 0H800z" },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_2_",
                gradientUnits: "userSpaceOnUse",
                x1: "467.447",
                y1: "287.892",
                x2: "480.211",
                y2: "287.892",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: "0" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("circle", {
            staticStyle: {
              opacity: ".6",
              fill: "url(#SVGID_2_)",
              "enable-background": "new",
            },
            attrs: { cx: "471", cy: "287.9", r: "3.6" },
          }),
          _c("circle", {
            staticClass: "st2",
            attrs: { cx: "65.1", cy: "48", r: "3.6" },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_3_",
                gradientUnits: "userSpaceOnUse",
                x1: "707.51",
                y1: "442.392",
                x2: "720.274",
                y2: "442.392",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: "0" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("circle", {
            staticStyle: {
              opacity: ".6",
              fill: "url(#SVGID_3_)",
              "enable-background": "new",
            },
            attrs: { cx: "711.1", cy: "442.4", r: "3.6" },
          }),
          _c("circle", {
            staticClass: "st2",
            attrs: { cx: "634.5", cy: "95.8", r: "3.6" },
          }),
          _c("circle", {
            staticClass: "st2",
            attrs: { cx: "646.5", cy: "139.4", r: "3.6" },
          }),
          _c("circle", {
            staticClass: "st2",
            attrs: { cx: "473.6", cy: "69", r: "3.6" },
          }),
          _c("path", {
            staticClass: "st2",
            attrs: {
              id: "texture_1_-i0",
              d: "M191.4 65.2c-.3.1-.4.3-.4.6.1.3.3.4.6.4.3-.1.4-.3.4-.6s-.3-.5-.6-.4zm-44.2 21.1c-.2-.2-.5-.1-.7.2-.2.2-.1.5.2.7.2.2.5.1.7-.2.2-.3 0-.6-.2-.7zm11 5.9c-.2-.2-.5-.1-.7.2s-.1.5.2.7c.2.2.5.1.7-.2.1-.1 0-.5-.2-.7zm10-22.4c-.2.2-.2.5-.1.8.2.2.5.2.8.1.2-.2.2-.5.1-.6-.2-.5-.5-.6-.8-.3zm7.9 9.8c-.2.2-.2.5-.1.8.2.2.5.2.8.1.2-.2.2-.5.1-.6-.2-.5-.6-.6-.8-.3zm-30.8 31.8c-.3 0-.6.2-.6.4 0 .3.2.6.4.6.3 0 .6-.2.6-.4.1-.3-.1-.5-.4-.6zm12.5 1.4c-.3 0-.6.2-.6.4 0 .3.2.6.4.6s.6-.2.6-.4c.1-.3-.1-.6-.4-.6zM178 62.4c-.1.1-.3.5-.1.6.1.1.5.3.6.1.1-.1.3-.5.1-.6-.1-.3-.3-.4-.6-.1zm6.2 9.3c-.1.1-.3.5-.1.6.1.1.3.3.6.1.1-.1.3-.3.1-.6-.2-.2-.4-.2-.6-.1zm-32.1 29.5c-.3 0-.5.1-.6.3 0 .3.1.4.3.6.3 0 .5-.1.6-.3 0-.3-.1-.6-.3-.6zm10.9 2.2c-.3 0-.5.1-.6.3 0 .3.1.4.3.6.3 0 .5-.1.6-.3 0-.3-.1-.6-.3-.6zm3.6-21.9c-.2-.2-.5-.1-.7.2-.2.2-.1.5.2.7s.5.1.7-.2c.1-.2 0-.5-.2-.7zm.8-24.3c-.2-.2-.5-.1-.7.2-.2.2-.1.5.2.7s.5.1.7-.2c.1-.3 0-.6-.2-.7zm10.7 7.2c-.2-.2-.5-.1-.7.2-.2.2-.1.5.2.7s.5.1.7-.2c.1-.3 0-.6-.2-.7zm10.8 7c-.2-.2-.5-.1-.7.2s-.1.5.2.7.5.1.7-.2c0-.2-.1-.5-.2-.7zm-32.4 38.9c-.3.1-.4.3-.4.6s.3.4.6.4c.3-.1.4-.3.4-.6s-.3-.5-.6-.4zm48.7-46.6c-.2-.3-.5-.3-.8-.1M162.8 83c-.3 0-.6.2-.6.4 0 .3.2.6.4.6.3 0 .6-.2.6-.4.1-.3-.2-.6-.4-.6zm-.5-8.9c-.3 0-.6.2-.6.4 0 .3.2.6.4.6s.5-.1.6-.4c.1-.2-.2-.5-.4-.6zm12.5 3c-.3 0-.6.2-.6.4 0 .3.1.5.4.6.3 0 .6-.2.7-.4 0-.3-.2-.6-.5-.6zm15.5-16.7c-.2-.2-.5-.1-.7.2-.2.2-.1.5.1.8.2.2.5.1.8-.1.2-.4.1-.7-.2-.9zm1.5 5c-.3 0-.4.1-.6.2 0 .3.1.4.2.6.3 0 .4-.1.6-.2 0-.3-.1-.6-.2-.6z",
            },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_4_",
                gradientUnits: "userSpaceOnUse",
                x1: "174.956",
                y1: "335.032",
                x2: "215.179",
                y2: "335.032",
                gradientTransform:
                  "matrix(1.7912 0 0 -1.7917 140.677 1133.488)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: ".005" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("path", {
            staticStyle: { fill: "url(#SVGID_4_)" },
            attrs: { d: "m454.1 552 20.1-37.5 20.1 37.5h-40.2z" },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_5_",
                gradientUnits: "userSpaceOnUse",
                x1: "46.612",
                y1: "311.921",
                x2: "64.18",
                y2: "311.921",
                gradientTransform:
                  "matrix(1.7912 0 0 -1.7917 140.677 1133.488)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: ".005" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("path", {
            staticStyle: { fill: "url(#SVGID_5_)" },
            attrs: { d: "m224.2 582.8 8.8-16.4 8.8 16.4h-17.6z" },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_6_",
                gradientUnits: "userSpaceOnUse",
                x1: "287.627",
                y1: "306.637",
                x2: "305.195",
                y2: "306.637",
                gradientTransform:
                  "matrix(1.7912 0 0 -1.7917 140.677 1133.488)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: ".005" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("path", {
            staticStyle: { fill: "url(#SVGID_6_)" },
            attrs: { d: "m655.9 592.3 8.8-16.4 8.8 16.4h-17.6z" },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_7_",
                gradientUnits: "userSpaceOnUse",
                x1: "142.055",
                y1: "330.049",
                x2: "159.623",
                y2: "330.049",
                gradientTransform:
                  "matrix(1.7912 0 0 -1.7917 140.677 1133.488)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: ".005" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("path", {
            staticStyle: { fill: "url(#SVGID_7_)" },
            attrs: { d: "m395.1 550.3 8.8-16.4 8.8 16.4h-17.6z" },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_8_",
                gradientUnits: "userSpaceOnUse",
                x1: "187.197",
                y1: "329.932",
                x2: "238.385",
                y2: "329.932",
                gradientTransform:
                  "matrix(1.7912 0 0 -1.7917 140.677 1133.488)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: ".005" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("path", {
            staticStyle: { fill: "url(#SVGID_8_)" },
            attrs: { d: "m476 561.1 25.6-37.5 25.6 37.5H476z" },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_9_",
                gradientUnits: "userSpaceOnUse",
                x1: "-21.846",
                y1: "308.852",
                x2: "36.318",
                y2: "308.852",
                gradientTransform:
                  "matrix(1.7912 0 0 -1.7917 140.677 1133.488)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: ".005" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("path", {
            staticStyle: { fill: "url(#SVGID_9_)" },
            attrs: { d: "m101.5 600 29.1-39.7 29.1 39.7h-58.2z" },
          }),
          _c("path", {
            staticStyle: { fill: "#fff" },
            attrs: {
              id: "texture_2_-i0",
              d: "M628.4 585.5c-.2-.1-.5-.1-.7.1-.1.2-.1.5.1.7.2.1.5.1.7-.1.2-.3.2-.6-.1-.7zm-41.7-19.7c0-.3-.3-.4-.5-.4-.3 0-.4.3-.4.5 0 .3.3.4.5.4.4.1.5-.3.4-.5zm2.3 11.5c0-.3-.3-.4-.5-.4-.3 0-.4.3-.4.5 0 .3.3.4.5.4.2.1.4-.2.4-.5zm22.3-6c-.3 0-.5.1-.6.4 0 .3.1.5.4.6.3 0 .5-.1.5-.3.2-.4.1-.6-.3-.7zm-2.4 11.6c-.3 0-.5.1-.6.4 0 .3.1.5.4.6.3 0 .5-.1.5-.3.1-.4-.1-.7-.3-.7zm-41.6-3.5c-.1-.2-.5-.3-.7-.2s-.3.5-.2.7c.1.2.5.3.7.2.3-.2.3-.5.2-.7zm6.5 9.9c-.1-.2-.5-.3-.7-.2s-.3.5-.2.7.5.3.7.2c.2-.1.3-.5.2-.7zm48.7-15.3c-.2 0-.5 0-.5.3 0 .2 0 .5.3.5.2 0 .5 0 .5-.3.2-.2 0-.4-.3-.5zm-3.1 10.1c-.2 0-.5 0-.5.3 0 .2 0 .4.3.5.2 0 .4 0 .5-.3 0-.3-.1-.5-.3-.5zm-40.6-5.9c-.1-.2-.4-.4-.6-.2s-.3.3-.2.6c.1.2.4.4.6.2.2-.2.3-.4.2-.6zm4.9 9.3c-.1-.2-.4-.4-.6-.2-.2.1-.3.3-.2.6.1.2.4.4.6.2.2-.2.3-.4.2-.6zm18-10.4c0-.3-.3-.4-.5-.4-.3 0-.4.3-.4.5 0 .3.3.4.5.4s.4-.2.4-.5zm18.3-13.9c0-.3-.3-.4-.5-.4-.3 0-.4.3-.4.5 0 .3.3.4.5.4s.4-.3.4-.5zm1.1 12c0-.3-.3-.4-.5-.4-.3 0-.4.3-.4.5s.3.4.5.4c.3 0 .4-.2.4-.5zm1.3 12.1c0-.3-.3-.4-.5-.4-.3 0-.4.3-.4.5 0 .3.3.4.5.4.2-.1.3-.3.4-.5zm-47.7-.4c-.2-.1-.5-.1-.7.1-.1.2-.1.5.1.7.2.1.5.1.7-.1.3-.2.2-.6-.1-.7zm63 7.7c.1-.3 0-.5-.4-.6m-38.9-18.8c-.1-.2-.5-.3-.7-.2s-.3.5-.2.7.5.3.7.2c.3-.2.4-.5.2-.7zm6.2-5.7c-.1-.2-.5-.3-.7-.2s-.3.5-.2.7.4.4.7.2c.2-.1.3-.4.2-.7zm5.3 10.9c-.1-.2-.5-.3-.7-.2s-.4.4-.2.7c.1.2.5.3.7.3.2-.2.3-.6.2-.8zm21.4 1.4c0-.3-.3-.4-.5-.4-.3 0-.4.3-.5.6 0 .3.3.4.6.5.2-.2.4-.4.4-.7zm-2.8 4.1c-.1-.2-.3-.3-.5-.3-.2.1-.3.3-.3.5.1.2.3.3.5.3.2-.2.4-.4.3-.5z",
            },
          }),
          _c("path", {
            staticClass: "st2",
            attrs: {
              id: "texture_3_-i0",
              d: "M726.8 108.9c-.3-.2-.5-.1-.7.1-.2.3-.1.5.1.7.3.2.5.1.7-.1.1-.3.1-.6-.1-.7zm-45.2-21.4c0-.3-.3-.5-.6-.4s-.5.3-.4.6c0 .3.3.5.6.4.3.1.4-.3.4-.6zM684 100c0-.3-.3-.5-.6-.4-.3 0-.5.3-.4.6 0 .3.3.5.6.4.2 0 .4-.3.4-.6zm24.2-6.5c-.3 0-.5.2-.7.4 0 .3.2.5.4.7.3 0 .5-.2.6-.3.2-.5.1-.7-.3-.8zm-2.6 12.6c-.3 0-.5.2-.7.4 0 .3.2.5.4.7.3 0 .5-.2.6-.3.2-.5 0-.9-.3-.8zm-45.1-3.8c-.1-.2-.5-.3-.7-.2-.2.1-.3.5-.2.7.1.2.5.3.7.2.3-.1.4-.5.2-.7zm7 10.7c-.1-.2-.5-.3-.7-.2-.2.1-.3.5-.2.7s.5.3.7.2c.3-.1.3-.4.2-.7zm52.8-16.6c-.2 0-.6 0-.6.3 0 .2 0 .6.3.6.2 0 .6 0 .6-.3.2-.3.1-.5-.3-.6zm-3.3 11c-.2 0-.6 0-.6.3 0 .2 0 .5.3.6.2 0 .5 0 .6-.3 0-.4-.1-.6-.3-.6zm-44-6.4c-.1-.2-.4-.4-.6-.3-.2.1-.3.3-.3.6.1.2.4.4.6.3.2-.1.4-.4.3-.6zm5.3 10c-.1-.2-.4-.4-.6-.3-.2.1-.3.3-.3.6.1.2.4.4.6.3.2-.1.4-.3.3-.6zm19.5-11.2c0-.3-.3-.5-.6-.4-.3 0-.5.3-.4.6 0 .3.3.5.6.4.3-.1.4-.3.4-.6zm19.8-15.1c0-.3-.3-.5-.6-.4s-.5.3-.4.6c0 .3.3.5.6.4.2-.1.4-.3.4-.6zm1.2 13.1c0-.3-.3-.5-.6-.4-.3 0-.5.3-.4.6 0 .3.3.5.6.4s.4-.3.4-.6zm1.4 13.1c0-.3-.3-.5-.6-.4-.3 0-.5.3-.4.6 0 .3.3.5.6.4.2-.2.4-.4.4-.6zm-51.6-.5c-.3-.2-.5-.1-.7.1-.2.3-.1.5.1.7s.5.1.7-.1c.2-.1.1-.6-.1-.7zm68.2 8.4c.1-.4 0-.6-.4-.7m-42.1-20.4c-.1-.2-.5-.3-.7-.2-.2.1-.3.5-.2.7s.5.3.7.2c.2-.1.3-.5.2-.7zm6.6-6.1c-.1-.2-.5-.3-.7-.2-.2.1-.3.5-.2.7s.4.4.7.2c.2-.1.3-.5.2-.7zm5.7 11.8c-.1-.2-.5-.3-.7-.2-.2.1-.4.4-.2.7.1.2.5.3.8.3.2-.2.3-.6.1-.8zm23.2 1.5c0-.3-.3-.5-.6-.4-.3 0-.5.3-.6.6 0 .3.3.5.6.6.5-.3.7-.5.6-.8zm-3 4.4c-.1-.2-.3-.3-.5-.3-.2.1-.3.3-.3.5.1.2.3.3.5.3.3-.1.4-.4.3-.5z",
            },
          }),
          _c("path", {
            staticClass: "st2",
            attrs: {
              d: "M66.6 521h-.2c-.3-.1-.4-.4-.3-.6l21-54c.1-.3.4-.4.6-.3.3.1.4.4.3.6l-21 54c0 .2-.2.3-.4.3zM84.6 500h-.2c-.3-.1-.4-.4-.3-.6l21-54c.1-.3.4-.4.6-.3.3.1.4.4.3.6l-21 54c0 .2-.2.3-.4.3zM95.1 492.5h-.2c-.3-.1-.4-.4-.3-.6l21-54c.1-.3.4-.4.6-.3.3.1.4.4.3.6l-21 54c0 .2-.2.3-.4.3zM671 206h-.2c-.3-.1-.4-.4-.3-.6l21-54c.1-.3.4-.4.6-.3.3.1.4.4.3.6l-21 54c0 .2-.2.3-.4.3zM689 185h-.2c-.3-.1-.4-.4-.3-.6l21-54c.1-.3.4-.4.6-.3.3.1.4.4.3.6l-21 54c0 .2-.2.3-.4.3zM699.5 177.5h-.2c-.3-.1-.4-.4-.3-.6l21-54c.1-.3.4-.4.6-.3.3.1.4.4.3.6l-21 54c0 .2-.2.3-.4.3z",
            },
          }),
        ],
        1
      ),
      _c(
        "g",
        { attrs: { transform: "matrix(1.2935 0 0 1.2925 552 383)" } },
        [
          _c("path", {
            staticClass: "st11",
            attrs: {
              d: "M202.6 18.8c5.8 3.3 9.5 9.5 11.3 16s2 13.2 2.7 19.9c.3 3.3.8 6.7 2.5 9.6 1.7 2.9 4.9 5.1 8.2 4.7 3.7-.4 6.7-3.8 10.3-3.6 1.6.1 3.1.8 4.3 1.8 3.9 3 5.7 7.8 8.1 12 2.4 4.2 6.5 8.3 11.3 8 3.9-.3 7.2-3.6 8.3-7.4 1.1-3.8.3-7.9-1.2-11.6",
            },
          }),
          _c("path", {
            staticClass: "st12",
            attrs: {
              d: "M337.2 171.3c5-1.3 13.8 1.8 15.9.9 6.4-2.5 13-1.4 19.2 2.6-1.6 3-5.5.3-8.7.1-3.3-.2-8.2 2.3-7.9 5.5 1.4 1.7 2.9 3.4 3.8 5.4 2-.1 3.8-.2 5.8-.3.6-1.7 2-3.1 1-4.6-.8-1.3-3.9-2.7-4.1-4.2-.3-2.6 5.4 1 7.9 1.2 1.9 1 .8 10.3.3 10.5-3 1.8-6.5 2.9-10 3.1 6.4 6.1 20.6 25.2 14.1 20.5-2.4-1.8-4.2-4.3-6.2-6.7-7-8.4-25.2-26-28.7-25.6-17.4 4.1-35.7 18.4-45.3 28.1-2.1-.7-12.4-5.2-11.5-7.3 3.9-8.6-.3-13 8.4-16.7 1.2-.3 34.2-9.5 46-12.5z",
            },
          }),
          _c("path", {
            staticClass: "st13",
            attrs: {
              d: "M256.7 201.2c-6.1-4.8-10.7-11.3-14.6-18-15-25.8-24-59-19-88.5 7.8 3.1 20.3 17.7 24.9 28.2 4.5 10.5 6.7 22 8.4 33.3 1.1 7.1 2.2 14.8 7.3 20 6.9 7.1 17.6 8.1 27.4 7.3-2.7 4.1-4.3 7.8-4.7 12.9-.4 5.1 2.1 10.8 6.9 12.5 1.4.5 2.8.6 4 1.4 1.2.8 1.9 2.6.9 3.7-.3.3-.8.6-1.2.7-4.4 1.7-8.5 17.4-13 16-9.2-3-19.6-23.4-27.3-29.5z",
            },
          }),
          _c("path", {
            staticClass: "st12",
            attrs: {
              d: "M375.6 204.4c-2.3-3.2-8-7.9-10.4-11.1 4 2 10.8 6.5 13 10.4.3.5.5 1 .3 1.5-.2.6-1.1.7-1.6.5-.6-.2-1-.8-1.3-1.3zM382.6 194.7c-3.7-1.9-10.9-3.9-15-3 1.3 1.4 6 2.6 7.8 3.2 3.2 1.1 6.3 2.2 9.5 3.3.6-1.4-.9-2.8-2.3-3.5zM48.2 171.3c-5-1.3-13.8 1.8-15.9.9-6.4-2.5-13-1.4-19.2 2.6 1.6 3 5.5.3 8.7.1 3.3-.2 8.2 2.3 7.9 5.5-1.4 1.7-2.9 3.4-3.8 5.4-2-.1-3.8-.2-5.8-.3-.6-1.7-2-3.1-1-4.6.8-1.3 3.9-2.7 4.1-4.2.3-2.6-5.4 1-7.9 1.2-1.9 1-.8 10.3-.3 10.5 3 1.8 6.5 2.9 10 3.1-6.4 6.1-20.6 25.2-14.1 20.5 2.4-1.8 4.2-4.3 6.2-6.7 7-8.4 25.2-26 28.7-25.6 17.4 4.1 35.7 18.4 45.3 28.1 5.7 7.9 12.6-2 11.6-4-3.9-8.6.1-16.2-8.5-20-1.3-.3-34.2-9.5-46-12.5z",
            },
          }),
          _c("path", {
            staticClass: "st13",
            attrs: {
              d: "M123 215c6.2-8.3 16.3-25 20.2-31.7 15-25.8 25-59.2 20-88.6-7.5 1.5-21.3 17.8-25.9 28.3-4.5 10.5-6.7 22-8.4 33.3-1.1 7.1-2.2 14.8-7.3 20-6.9 7.1-17.6 8.1-27.4 7.3 2.7 4.1 4.3 7.8 4.7 12.9S96.8 207.3 92 209c-1.4.5-2.8.6-4 1.4-1.2.8-1.9 2.6-.9 3.7.3.3.8.6 1.2.7 4.4 1.7 8.5 17.4 13 16 9.3-3.1 15.9-8 21.7-15.8z",
            },
          }),
          _c("path", {
            staticClass: "st12",
            attrs: {
              d: "M7.5 206.3c2.3-3.2 8-7.9 10.4-11.1-4 2-10.8 6.5-13 10.4-.3.5-.5 1-.3 1.5.2.6 1.1.7 1.6.5.5-.2.9-.7 1.3-1.3zM2.4 196.2c3.7-1.9 10.9-3.9 15-3-1.3 1.4-6 2.6-7.8 3.2-3.2 1.1-6.3 2.2-9.5 3.3-.6-1.4.9-2.8 2.3-3.5z",
            },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_10_",
                gradientUnits: "userSpaceOnUse",
                x1: "1092.877",
                y1: "-1149.24",
                x2: "2927.664",
                y2: "-1149.24",
                gradientTransform: "matrix(.207 0 0 -.2068 -176.935 1.182)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#28306d" },
                attrs: { offset: "0" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#1f275f" },
                attrs: { offset: ".51" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#171f51" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("path", {
            staticStyle: { fill: "url(#SVGID_10_)" },
            attrs: {
              d: "M249.9 265.8c-10.7 3.7-21.7 7.5-33 7.5-8.4 0-37.1 5.3-45.3 3.2-14.1-3.6-32.6-5-46.7-8.6-16-4.1-7.3-17.7-22.7-23.6-16.4-6.3-30 5.6-44.1-5-1.3-1-7.8-8.1-8.6-9.5-1.3-2.6 1.3-9 2.9-11.4 4.9-7.6 15.8-10.6 24.8-11.4 10.8-1.1 62.6 14.1 73.4 14.3 25.7.6 27.8 7 53.4 9.5 45.2 4.4 72.9-32.3 118.2-29.8 5.8.3 12.1 1.1 16.3 5.1 6.6 6.2 4.9 17.8-1.1 24.6-6 6.8-15 10-23.6 13-21.2 7.3-42.6 14.7-63.9 22.1z",
            },
          }),
          _c("path", {
            staticClass: "st11",
            attrs: {
              d: "M180.9 15c-2.8-4.9-1.3-11.8 3.3-15M185.7 16.2c-1.4-.1-2-1.9-2-3.3.1-5.1 3.8-9.9 8.7-11.2",
            },
          }),
          _c("path", {
            staticClass: "st15",
            attrs: {
              d: "M179.6 39.5c-.9-7.5-1.3-16.2 4.3-21.4 6-5.6 16.4-3.6 21.9 2.4 5.6 6 7.2 14.7 7.2 22.8 0 6.5-.8 13.2 1.4 19.3 2.1 6.1 8.5 11.5 14.7 9.8 1.8-.5 3.5-1.5 5.3-1.9 5.4-1 9.9 4 12.4 8.8 2.5 4.8 4.8 10.5 9.8 12.7 4.2 1.9 9.3.6 12.8-2.3s5.7-7.1 7-11.5c1.8 6.5-.6 13.2-4.4 18.7-1.9 2.8-5.8 5.5-9.1 6.3-4.5 1.1-8.7-2.4-11.5-6-2.7-3.7-5-8-9-10.2-8.5-4.5-21.3 2.3-27.4-5.1-2.5-3-2.7-7.6-5.5-10.4-3.5-3.5-9.3-2.8-14.1-4.2-5.4-1.6-9.6-6.2-12-11.3-2.2-5.2-3.1-10.9-3.8-16.5z",
            },
          }),
          _c("path", {
            staticClass: "st15",
            attrs: {
              d: "M177.5 70.3c4.5-2.8 5.6-8.7 6.4-13.9.8-5.8 1.6-11.5 2.4-17.3 1.2-8.5 1.9-18.6-4.6-24.3-4.8 1-9.3 3.7-12.5 7.4-3.1 3.6-5 8.1-6.7 12.6-2.3 6.1-4.4 12.3-6.2 18.6-1.2 4.3-2.3 8.6-4.5 12.5-2.2 3.9-5.6 7.2-9.9 8.3-8 2-17.5-4.3-24.2.5-1.4 1-2.5 2.5-4.1 3.2-2.2 1-4.7.4-7-.2-3.2-.8-6.6-1.8-8.8-4.2-1.7-1.8-2.9-4.7-5.4-4.7 1.2 2.4 2.5 4.8 3.7 7.1 1.5 3 3.1 6 5.6 8.3 2.5 2.2 6.1 3.6 9.2 2.4 3.4-1.2 5.4-4.7 8.6-6.3 5.4-2.7 11.6 1 17.5 2.3 6.6 1.5 13.9-.1 19.2-4.3 1.9-1.5 3.5-3.3 5.7-4.4 4.7-2.4 11-.7 15.6-3.6z",
            },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "L_shoe_1_-i1_1_",
                gradientUnits: "userSpaceOnUse",
                x1: "-7002.895",
                y1: "-878.152",
                x2: "-5428.767",
                y2: "-2331.191",
                gradientTransform:
                  "matrix(-.037 -.1089 -.1088 .03697 -140.998 -344.491)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: "0" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("path", {
            staticStyle: {
              opacity: ".6",
              fill: "url(#L_shoe_1_-i1_1_)",
              "enable-background": "new",
            },
            attrs: {
              id: "L_shoe_1_-i1",
              d: "m196.8 303.4 36.8-29.2 36 105.9s-12.3-1.9-26.2-17.3c-13.9-15.5-35.5-27-35.5-27l-11.1-32.4",
            },
          }),
          _c("ellipse", {
            staticClass: "st12",
            attrs: {
              transform: "rotate(-85.798 188.322 41.976) scale(.99999)",
              cx: "188.3",
              cy: "42",
              rx: "29.5",
              ry: "21.2",
            },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_11_",
                gradientUnits: "userSpaceOnUse",
                x1: "1797.65",
                y1: "-246.262",
                x2: "1909.046",
                y2: "-282.525",
                gradientTransform:
                  "matrix(.2064 .01513 .01512 -.2063 -184.288 -5.254)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#ffbeb6" },
                attrs: { offset: "0" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#f2a19c" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("path", {
            staticStyle: { fill: "url(#SVGID_11_)" },
            attrs: {
              d: "M196.3 59.1c.4 13.9.4 24.8 1.4 36.9-5.7.7-12.8.1-18.4-.8 1.9-5.5 1.6-11.5 1.4-17.3-.3-6.8.6-12.8 1.2-19.7.5-7 14.1-9.8 14.4.9z",
            },
          }),
          _c("path", {
            staticStyle: { fill: "none" },
            attrs: {
              d: "M183.7 36.4c.9-2.4 2.3-4.7 4.1-6.5.8 2.1 2.5 3.9 4.6 4.8-.3-.5-.5-1-.8-1.6",
            },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_12_",
                gradientUnits: "userSpaceOnUse",
                x1: "1754.964",
                y1: "-126.104",
                x2: "1802.332",
                y2: "-126.104",
                gradientTransform: "matrix(.207 0 0 -.2068 -176.935 1.182)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#ffbeb6" },
                attrs: { offset: "0" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#f2a19c" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("path", {
            staticStyle: { fill: "url(#SVGID_12_)" },
            attrs: {
              d: "M191 24.5c.8 1.2 1.8 2.6 2.7 3.8.5.7.1 1.7-.8 1.8-1.7.2-3.8.3-5.4.3-.9 0-1.4-.9-1-1.7.7-1.4 1.8-3.1 2.7-4.3.4-.5 1.3-.5 1.8.1z",
            },
          }),
          _c("path", {
            staticClass: "st12",
            attrs: {
              d: "M163.6 47.9c.8 1.6 1.7 3.1 3.2 4 1.5.9 3.8.7 4.7-.8.5-.9.5-2 .3-3-.4-2.9-1.8-5.6-3.8-7.7-.4-.5-.9-.9-1.5-1.1-1.8-.7-3.9 1-4.3 3-.3 1.9.5 3.9 1.4 5.6zM206.4 54.3c-.6.4-1.3.8-1.9.6-.9-.4-.8-3.2-.4-4.1 1.2-3.6 2.6-10.4 6.4-10.1 2.2.1 1.9 7 .8 9-1.2 1.8-3 3.2-4.9 4.6z",
            },
          }),
          _c("path", {
            staticClass: "st13",
            attrs: {
              d: "M153.5 178.3c.1-8.7-12.6-52.9-9.5-60.7 4.2-10.6 3.4-12.8 17.1-22.1 6.7-4.5 19.2-6.6 19.2-6.6s2.5 3.5 5.7 4.4c3.3.9 10.5-1.7 11-5 6.4 1 15 2.2 20.2 4.1 7.5 2.8 8.8 1.2 15.7 17.6s6.4 36.7 1.3 71.1c-1.3 8.6 16.3 27 23.9 32.2 0 0-4.1 5.9-9.9 11-16.8 14.6-47.7 28-64.8 12.1-20.3-18.8-23.5-9.5-45.8-19.7-3.8-1.7-7-7-7-7s22.9-27.8 22.9-31.4z",
            },
          }),
          _c("path", {
            staticClass: "st20",
            attrs: {
              d: "M249.9 98.5c-.3 0-.5-.2-.6-.5-.8-5 3-9 6.6-12.3.5-.4.7-.7.8-.9-1 .2-3.8 1.4-6 3.7-.6.7-1.4 2-2.1 3.2-1.4 2.3-2 3.4-2.8 3.2-.4-.1-.7-.5-.7-1.1-.4-3.1 3.5-11.3 9-13.5.3-.1.6 0 .8.3.1.3 0 .6-.3.8-4.7 1.9-8.4 9.2-8.3 12.1.4-.5 1-1.6 1.5-2.3.8-1.3 1.6-2.7 2.3-3.4 2.5-2.6 6.2-4.4 7.5-4.1.3.1.6.3.7.6.1.6-.3 1.2-1.4 2.2-3.4 3.1-6.9 6.8-6.2 11.3-.2.4-.4.7-.8.7zM114.7 87.7s-.1 0 0 0c-.4 0-.6-.3-.6-.6.4-4.4-1.5-8.9-4.8-11.8-.2-.2-.3-.6-.1-.8.2-.2.6-.3.8-.1 1.2 1 2.2 2.2 3 3.6-.2-.6-.3-1.1-.5-1.6-.2-.6-.3-1.2-.4-1.6-.3-1.1.4-1.4.6-1.4 1.3-.4 3.6 1.9 4.6 4.5.1.3.2.6.3 1 .4 1.2 1 3.1 1.7 3.4.1 0 .2.1.4-.1l.9-.6c1.1-.7 2.2-1.6 3.6-.9.3.1.4.5.3.8-.1.3-.5.4-.8.3-.7-.4-1.4.1-2.5.8-.3.2-.7.5-1 .7-.6.3-1.1.3-1.4.1-1.2-.5-1.8-2.4-2.4-4.1-.1-.3-.2-.7-.3-1-.8-2.1-2.3-3.5-3-3.7.1.4.2.9.4 1.5.8 2.9 2.2 7.6 1.5 11.2.2.2 0 .4-.3.4z",
            },
          }),
          _c("path", {
            staticClass: "st15",
            attrs: {
              d: "M175.8 264.4c-19.5-18.5-41.2-34.5-64.6-47.8-12.4-7-26.2-13.4-40.3-12s-28.2 13.7-26.4 27.9c.7 5.4 3.5 10.4 6.6 14.9 24.6 35.9 68.5 52.2 109.6 66.5 13.8 4.8 27.6 9.6 41.3 14.4 2.3.8 5 1.5 7 .2 1.3-.8 1.9-2.3 2.5-3.7 4.5-10.3 8.7-23.2 1.6-31.9-3.5-4.3-9-6.4-13.9-9.1-8.9-5-16.1-12.4-23.4-19.4z",
            },
          }),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_13_",
                gradientUnits: "userSpaceOnUse",
                x1: "2030.896",
                y1: "-1262.294",
                x2: "2411.774",
                y2: "-1262.294",
                gradientTransform:
                  "matrix(.1987 .05795 .0579 -.1985 -188.295 -25.841)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: "0" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#a1e7fc" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("path", {
            staticStyle: {
              opacity: ".6",
              fill: "url(#SVGID_13_)",
              "enable-background": "new",
            },
            attrs: {
              d: "M215.9 307c-8.2 3.2-14.5 10.7-16.2 19.3-.5 2.4-.6 4.8-1.6 7-.8 1.9 4.9 3.7 3.2 5-21 15.7-35.3 55.7-57.2 61.7 1.2-16.7 5.4-42.6 6.6-59.3 1.3-17.9 2.9-27.6 4.7-44.1.1-.6.4-1.2.9-1.6.6-.4 1.5-.3 2.2-.1 19.2 4.1 38.3 8.1 57.4 12.1z",
            },
          }),
          _c("path", {
            staticClass: "st15",
            attrs: {
              d: "M345.2 217.3c.7 7.6-3.2 14.9-8.1 20.7-6.6 7.9-15 14-23.3 19.9-37.7 27-75.3 54.1-113 81.1-7.6-3.7-12.7-12.1-12.3-20.5.3-7.8 4.8-14.8 9.4-21.2 23.2-32.6 51.6-61.5 83.9-85.2 10.5-7.7 22-15 35-15.7 13-.6 27.3 8 28.4 20.9z",
            },
          }),
          _c("path", {
            staticClass: "st20",
            attrs: {
              d: "M199.9 15.5c-2.1.1-4 .6-5.4 1.5-.8.5-1.4 1.1-1.8 1.7-1.9-.9-4.4-.6-6.1.8-.8-1.6-3-2.6-5.8-2.6-.9 0-1.8.1-2.7.3-2 .4-3.8 1.3-5.1 2.4-1.3 1.2-1.9 2.6-1.6 3.9.4 2 2.8 3.3 6.1 3.3.9 0 1.8-.1 2.7-.3 2-.4 3.8-1.3 5.1-2.4 1.2-1.1 1.8-2.4 1.7-3.6 1.5-1.4 3.7-1.8 5.4-.9-.1.3-.1.6-.1.9.1 2.5 3.4 4.5 7.6 4.5h.4c2.1-.1 4-.6 5.4-1.5 1.5-.9 2.3-2.2 2.3-3.5-.2-2.6-3.8-4.6-8.1-4.5zm-15.4 7.9c-1.1 1-2.8 1.8-4.7 2.2-.8.2-1.7.3-2.5.3-2.7 0-4.8-1-5.1-2.5-.2-.9.3-2 1.4-3 1.1-1 2.8-1.8 4.7-2.2.8-.2 1.7-.3 2.5-.3 2.7 0 4.8 1 5.1 2.5.1 1-.3 2-1.4 3zm20.6-.6c-1.3.8-3.1 1.3-5 1.3-3.8.1-7-1.5-7.1-3.6 0-1 .6-1.9 1.9-2.7 1.3-.8 3.1-1.3 5-1.3h.4c3.6 0 6.6 1.6 6.7 3.6 0 .9-.7 1.9-1.9 2.7z",
            },
          }),
          _c("path", {
            staticStyle: {
              opacity: ".51",
              fill: "#fff",
              "enable-background": "new",
            },
            attrs: {
              id: "texture-3_1_-i1",
              d: "M95 234.4c-.1 0-.2 0-.3-.1 0-.1 0-.2.1-.3.1 0 .2 0 .3.1.1.1 0 .2-.1.3zm-1.7-4.7c-.1 0-.2 0-.3-.1 0-.1 0-.2.1-.3s.2 0 .3.1c.1.1 0 .3-.1.3zm-1.7-4.7c-.1 0-.2 0-.3-.1 0-.1 0-.2.1-.3.1 0 .2 0 .3.1.1.2 0 .3-.1.3zm-1.7-4.6c-.1 0-.2 0-.3-.1 0-.1 0-.2.1-.3.1 0 .2 0 .2.1.1.1.1.2 0 .3zm-1.7-4.7c-.1 0-.2 0-.3-.1 0-.1 0-.2.1-.3s.2 0 .3.1c0 .2 0 .3-.1.3zM74 233.5c-.1 0-.1-.2-.1-.3 0-.1.2-.1.3-.1.1 0 .1.2.1.3-.1.1-.2.1-.3.1zm2.1-4.5c-.1-.1-.2-.2-.1-.3.1-.1.2-.1.3-.1.1 0 .1.1.1.2-.1.2-.2.2-.3.2zm2-4.5c-.1 0-.1-.2-.1-.3.1-.1.2-.2.3-.1.1.1.1.2.1.3 0 .1-.2.1-.3.1zm2.1-4.5c-.1 0-.1-.2-.1-.3.1-.1.2-.2.3-.1.1 0 .1.2.1.3 0 .1-.2.1-.3.1zM60 218.1c-.1 0-.2 0-.3-.1 0-.1 0-.2.1-.2s.2 0 .3.1c0 .1 0 .2-.1.2zm42.6 8.5c-.1.1-.2.1-.3 0-.1-.1-.1-.2 0-.3.1-.1.2-.1.3 0 .1.1.1.2 0 .3zm-3.3-3.6s-.1 0 0 0c-.2.1-.2 0-.3 0-.1-.1-.1-.2 0-.3.1-.1.2-.1.3 0 0 0 .1.1 0 .3 0-.1 0-.1 0 0zm-3.4-3.7c-.1.1-.2.1-.3 0-.1-.1-.1-.2 0-.3.1-.1.2-.1.3 0 .1.1.1.2 0 .3zm-11.2 14c-.1 0-.2-.1-.2-.2s.1-.2.2-.2.2.1.2.2c0 .2-.1.2-.2.2zm.2-4.9c-.1 0-.2-.1-.2-.2s0-.1.1-.2h.1c.1 0 .2.1.2.2s-.1.2-.2.2zm.2-5c-.1 0-.2-.1-.2-.2s.1-.2.2-.2.2.1.2.2-.1.2-.2.2zm.2-4.9c-.1 0-.2-.1-.2-.2s.1-.2.2-.2.2.1.2.2-.1.2-.2.2zm-17.7 7c-.1.1-.2.1-.3 0-.1-.1-.1-.2 0-.3s.2-.1.3 0v.3zm3.6-3.4c-.1.1-.2.1-.3 0-.1-.1-.1-.2 0-.3.1-.1.2-.1.3 0 .1.1.1.2 0 .3zm49.5 18.9c-.2-.2-.2-.4-.1-.6.2-.2.4-.2.6 0l.1.1c-.2.2-.4.3-.6.5zm-6.3-6.5s-.1.1-.2.1c-.1.1-.3 0-.4-.1-.2-.2-.2-.4 0-.6.1-.2.4-.2.5 0 .2.2.2.4.1.6zm-6.8-6.5c-.2.2-.4.2-.6 0-.2-.1-.2-.4 0-.5.2-.2.4-.2.6 0 .1.1.1.3 0 .5zm-16.3 26.3c-.2 0-.4-.2-.4-.4s.2-.4.4-.4.4.2.4.4-.2.4-.4.4zm-.2-9.4c-.2 0-.4-.2-.4-.4s.2-.4.4-.4.4.2.4.4-.2.4-.4.4zm-.3-9.4c-.2 0-.4-.2-.4-.4s.2-.4.4-.4.4.2.4.4-.1.4-.4.4zm-.2-9.4c-.2 0-.3-.1-.4-.2v-.1c0-.1 0-.2.1-.2.1-.1.2-.2.3-.2.2 0 .4.2.4.4 0 .1-.2.3-.4.3zm-.3-9.5c-.2 0-.4-.2-.4-.4s.2-.4.4-.4.4.2.4.4c0 .3-.1.4-.4.4.1 0 .1 0 0 0zm-35.4 32.8c-.2.2-.4.2-.6 0-.2-.1-.2-.4 0-.5.2-.2.4-.2.6 0 .1.1.1.3 0 .5zm6.4-6.9c-.1.2-.4.2-.6 0-.2-.1-.2-.4 0-.6.1-.2.4-.2.5 0 .3.2.3.5.1.6zm6.5-6.8c-.1.2-.4.2-.5 0-.2-.1-.2-.4 0-.5.2-.2.4-.2.6 0 .1.1.1.4-.1.5zm6.5-6.8c-.2.2-.4.2-.6 0-.2-.2-.2-.4 0-.6.1-.2.4-.2.5 0 .2.2.2.4.1.6zm6.5-6.8c-.1.2-.4.2-.5 0s-.2-.4 0-.5c.1-.2.4-.2.5 0 .1.1.1.3 0 .5zm25.4 24.4c-.2.1-.4 0-.5-.2-.1-.2 0-.4.2-.5.2-.1.4 0 .5.2.1.2 0 .4-.2.5zm-3.8-8.6c-.2.1-.4 0-.5-.2-.1-.2 0-.4.2-.5.2-.1.4 0 .5.2 0 .2 0 .4-.2.5zm-3.9-8.6c-.2.1-.4 0-.5-.2-.1-.2 0-.4.2-.5.2-.1.4 0 .5.2.1.2 0 .4-.2.5zm-3.8-8.6c-.2.1-.4 0-.5-.2-.1-.2 0-.4.2-.5.2-.1.4 0 .5.2.1.2 0 .4-.2.5zm-21 35.6c-.2-.1-.3-.3-.2-.5.1-.2.3-.3.5-.2.2.1.3.3.2.5 0 .2-.3.3-.5.2zm3.4-8.8c-.2-.1-.3-.3-.2-.5.1-.2.3-.3.5-.2.2.1.3.3.2.5-.1.2-.3.3-.5.2zm3.4-8.7c-.2-.1-.3-.3-.2-.5.1-.2.3-.3.5-.2.2.1.3.3.2.5-.1.1-.3.2-.5.2zm3.4-8.8c-.2-.1-.3-.3-.2-.5.1-.2.3-.3.5-.2.2.1.3.3.2.5-.1.1-.3.2-.5.2zm3.3-8.8c-.2-.1-.3-.3-.2-.5.1-.2.3-.3.5-.2.2.1.3.3.2.5-.1.2-.3.3-.5.2zm-39.5 10.6c-.2.1-.4 0-.5-.2-.1-.2 0-.4.2-.5.2-.1.4 0 .5.2.1.1 0 .4-.2.5zm8.6-3.9c-.2.1-.4 0-.5-.2-.1-.2 0-.4.2-.5.2-.1.4 0 .5.2.1.2 0 .4-.2.5zm8.6-3.8c-.2.1-.4 0-.5-.2-.1-.2 0-.4.2-.5.2-.1.4 0 .5.2.1.2 0 .4-.2.5zm8.6-3.8c-.2.1-.4 0-.5-.2-.1-.2 0-.4.2-.5.2-.1.4 0 .5.2.1.2 0 .4-.2.5zm39.7 27.1c0-.1.1-.2.2-.2h.2c-.2 0-.3.1-.4.2zm-3.7-6.9c-.2.1-.4 0-.5-.1-.1-.2 0-.4.1-.5.2-.1.4 0 .5.1.2.1.1.4-.1.5zm-4.1-7.4c-.2.1-.4 0-.4-.1-.1-.2 0-.4.1-.5.2-.1.4 0 .5.1 0 .2 0 .5-.2.5zm-4.1-7.3c-.2.1-.4 0-.4-.1-.1-.2 0-.4.1-.5h.2c.2 0 .3.2.3.3-.1.2-.1.3-.2.3zm-18.9 33.6c-.2-.1-.3-.2-.2-.4.1-.2.2-.3.4-.2.2 0 .3.2.2.4 0 .1-.2.3-.4.2zm2.3-8.1c-.2-.1-.3-.2-.2-.4 0-.2.2-.3.4-.3s.3.2.3.4c-.1.3-.3.4-.5.3zm2.5-8.1c-.1 0-.2.1-.2 0-.2-.1-.3-.2-.2-.4.1-.2.2-.3.4-.3.1 0 .2.1.2.2v.2c-.1.2-.1.3-.2.3zm2-8.1c-.2-.1-.3-.2-.2-.4s.2-.3.4-.2c.2.1.3.2.2.4 0 .2-.2.3-.4.2zm2.2-8.1c-.2-.1-.3-.3-.2-.4.1-.2.2-.3.4-.2.2 0 .3.2.3.4s-.3.3-.5.2zm2.3-8c-.2-.1-.3-.3-.2-.4.1-.2.2-.3.4-.2.2.1.3.2.3.4-.1.1-.3.2-.5.2zm-38.9 18.6c-.2.1-.4 0-.5-.1-.1-.2 0-.4.1-.5.2-.1.4 0 .5.1.2.2.1.4-.1.5zm7.3-4.1c-.2.1-.4 0-.5-.1-.1-.2 0-.4.1-.5.2-.1.4 0 .5.1.2.2.1.4-.1.5zm7.4-4.2c-.2.1-.4 0-.5-.1-.1-.2 0-.4.1-.4.2-.1.4 0 .5.1.1.1 0 .3-.1.4zm7.3-4.1c-.2.1-.4 0-.5-.1-.1-.2 0-.4.1-.5.2-.1.4 0 .5.1.1.2 0 .4-.1.5zm7.3-4.1c-.2.1-.4 0-.5-.1-.1-.2 0-.4.1-.5.2-.1.4 0 .5.1.1.2.1.4-.1.5zm7.3-4.2c-.2.1-.4 0-.5-.1-.1-.2 0-.4.1-.5.2-.1.4 0 .5.1.1.2.1.4-.1.5zm8.2 31.5c-.2 0-.4-.1-.4-.3 0-.2.1-.3.3-.4.2 0 .4.1.4.3.1.2-.1.4-.3.4zm-1-8.3c-.2 0-.4-.1-.4-.3 0-.2.1-.4.3-.4.2 0 .4.1.4.3 0 .2-.1.4-.3.4zm-1-8.3c-.2 0-.4-.1-.4-.3 0-.2.1-.4.3-.4.2 0 .4.1.4.3 0 .2-.1.3-.3.4zm-1-8.4c-.2 0-.4-.1-.4-.3 0-.2.1-.4.3-.4.2 0 .4.1.4.3 0 .2-.1.4-.3.4zm-26.8 24.9c-.1.1-.3.2-.5.1s-.2-.3-.1-.5c.1-.1.3-.2.5-.1s.3.3.1.5zm5.2-6.6c-.1.1-.3.2-.5.1s-.2-.3-.1-.5c.1-.1.3-.2.5-.1s.2.3.1.5zm5.2-6.6c-.1.2-.3.2-.5.1s-.2-.3-.1-.5.3-.2.5-.1.2.3.1.5zm5.2-6.7c-.1.2-.3.2-.5.1-.1-.1-.1-.2-.1-.3 0-.1 0-.1.1-.2s.3-.2.5-.1c.1.2.1.4 0 .5zm5.1-6.6c-.1.2-.3.2-.5.1-.1-.1-.2-.3-.1-.5l.1-.1h.2c.1 0 .1 0 .2.1.2.1.3.3.1.4zm-37-1.2c-.2 0-.3-.1-.4-.3 0-.2.1-.4.3-.4.2 0 .4.1.4.3.1.2 0 .4-.3.4.1 0 .1 0 0 0zm8.4-1c-.2 0-.4-.1-.4-.3 0-.2.1-.4.3-.4.2 0 .4.1.4.3 0 .2-.1.3-.3.4zm25-3.1c-.2 0-.4-.1-.4-.3 0-.2.1-.4.3-.4.2 0 .4.1.4.3 0 .2-.1.4-.3.4zm30.5 22c-.1.1-.2.1-.3 0-.1-.1-.1-.2 0-.3.1-.1.2-.1.3 0 .1.1.1.2 0 .3 0-.1 0-.1 0 0zm-3.2-3.8c-.1.1-.2.1-.3 0 0 0-.1-.1 0-.2 0-.1 0-.1.1-.1.1-.1.2-.1.3 0 0 .1.1.1 0 .2-.1 0-.1.1-.1.1zm-3.2-3.8c-.1.1-.2.1-.3 0s-.1-.2 0-.3c.1-.1.2-.1.3 0 .1.1 0 .3 0 .3zM97.4 245c-.1 0-.2-.1-.2-.2s.1-.2.2-.2.2.1.2.2-.1.2-.2.2zm.4-5c-.1 0-.2-.1-.2-.2s.1-.2.2-.2.2.1.2.2-.1.2-.2.2zm.4-4.9c-.1 0-.2-.1-.2-.2s.1-.2.2-.2.2.1.2.2-.1.2-.2.2zm.4-5c-.1 0-.2-.1-.2-.2s.1-.2.2-.2.2.1.2.2c0 .2-.1.2-.2.2zm.4-4.9c-.1 0-.2-.1-.2-.2s.1-.2.2-.2.2.1.2.2-.1.2-.2.2zm-20 10.2c-.1.1-.2.1-.3 0-.1-.1-.1-.2 0-.3s.2-.1.3 0c.1.1.1.3 0 .3zm3.7-3.2c-.1.1-.2.1-.3 0-.1-.1-.1-.2 0-.3.1-.1.2-.1.3 0 .1.1.1.2 0 .3.1 0 .1 0 0 0zm3.8-3.2c-.1.1-.2.1-.3 0-.1-.1-.1-.2 0-.3.1-.1.2-.1.3 0 .1.1.1.2 0 .3zm3.8-3.2c-.1.1-.2 0-.3 0-.1-.1-.1-.2 0-.3.1-.1.2-.1.2 0 .2.1.2.2.1.3zm3.7-3.2c-.1.1-.2.1-.3 0-.1-.1-.1-.2 0-.3.1-.1.2-.1.3 0 .1.1.1.2 0 .3zm-6.8-5.8c-.1 0-.2-.1-.2-.2s.1-.2.2-.2.2.1.2.2-.1.2-.2.2zm4.9.4c-.1 0-.2-.1-.2-.2s.1-.2.2-.2.2.1.2.2c.1.1 0 .2-.2.2zm15.5 23.9c-.1 0-.2 0-.3-.1 0-.1 0-.2.1-.3.1 0 .2 0 .3.1 0 .1 0 .3-.1.3zm-1.6-4.7c-.1 0-.2 0-.3-.1 0-.1 0-.2.1-.3.1 0 .2 0 .2.1.2.1.2.2 0 .3.1 0 .1 0 0 0zm-1.5-4.7c-.1 0-.2 0-.3-.1 0-.1 0-.2.1-.2s.2 0 .3.1c.1 0 0 .1-.1.2zM103 227c-.1 0-.2 0-.3-.1 0-.1 0-.2.1-.3.1 0 .2 0 .3.1.1.1 0 .2-.1.3zm-14.5 12.8c-.1-.1-.1-.2-.1-.3 0-.1.2-.1.3-.1.1 0 .1.2.1.3-.1.1-.2.1-.3.1zm2.2-4.5c-.1-.1-.1-.2-.1-.3.1-.1.2-.1.3-.1.1 0 .1.2.1.3 0 .1-.1.2-.3.1.1 0 .1 0 0 0zm2.3-4.4c-.1 0-.1-.2-.1-.3.1-.1.2-.1.3-.1.1.1.1.2.1.3-.1.1-.2.2-.3.1zm2.3-4.4c-.1 0-.1-.2-.1-.3.1-.1.2-.1.3-.1.1.1.1.2.1.3-.1.1-.2.2-.3.1zm2.2-4.4c-.1 0-.1-.2-.1-.3 0-.1.2-.1.3-.1.1.1.1.2.1.3-.1.1-.2.1-.3.1zm-21.3 3.4c-.1 0-.2 0-.3-.1 0-.1 0-.2.1-.3.1 0 .2 0 .2.1.2.1.1.2 0 .3 0-.1 0-.1 0 0zm4.7-1.6c-.1 0-.2 0-.3-.1 0-.1 0-.2.1-.2s.2 0 .2.1c.2.1.1.2 0 .2zm4.8-1.5c-.1 0-.2 0-.3-.1 0-.1 0-.2.1-.3.1 0 .2 0 .3.2 0 .1 0 .2-.1.2zm4.7-1.5c-.1 0-.2 0-.3-.1v-.2l.1-.1c.1 0 .2 0 .3.1v.1c0 .1-.1.1-.1.2zm4.7-1.6c-.1 0-.2 0-.3-.1 0-.1 0-.2.1-.3.1 0 .2 0 .3.1 0 .2 0 .3-.1.3zm-4.6-2.1c-.1 0-.2-.2-.2-.3 0-.1.2-.2.3-.2.1 0 .2.2.2.3 0 .2-.2.2-.3.2zm26.6 25.6c-.1.1-.3 0-.3-.1-.1-.1 0-.3.1-.3.1-.1.3 0 .3.1.1.1 0 .2-.1.3zm-2.8-4.9c-.1.1-.3 0-.3-.1-.1-.1 0-.3.1-.3.1-.1.3 0 .3.1s0 .2-.1.3zm-2.8-4.9c-.1.1-.3 0-.3-.1-.1-.1 0-.3.1-.3.1-.1.3 0 .3.1s0 .3-.1.3zm-15.3 17.9c-.1 0-.2-.2-.2-.3 0-.1.2-.2.3-.2.1 0 .2.2.2.3-.1.1-.2.2-.3.2zm1.4-5.5c-.1 0-.2-.2-.2-.3s.2-.2.3-.2c.1 0 .2.2.2.3 0 .2-.1.2-.3.2.1 0 .1 0 0 0zm1.5-5.4c-.1 0-.2-.1-.2-.3 0-.1.2-.2.3-.2.1 0 .2.2.2.3 0 .1-.2.2-.3.2zm1.4-5.5c-.1 0-.2-.2-.2-.3 0-.1.2-.2.3-.2.1 0 .1.1.2.2v.2s-.1.1-.3.1zm1.5-5.5c-.1 0-.2-.2-.2-.3 0-.1.1-.2.3-.2.1 0 .2.2.2.3 0 .2-.2.3-.3.2zm-24.6 7.4c-.1.1-.2 0-.3-.1-.1-.1 0-.3.1-.3.1-.1.3 0 .3.1.1.1.1.2-.1.3zm4.9-2.8c-.1.1-.3 0-.3-.1-.1-.1 0-.3.1-.3.1-.1.3 0 .3.1.1.1.1.2-.1.3zm4.9-2.9c-.1.1-.2 0-.3 0-.1-.1 0-.3.1-.3.1-.1.3 0 .3.1.1 0 0 .2-.1.2zm4.9-2.8c-.1.1-.2 0-.3 0-.1-.1 0-.3.1-.3.1-.1.3 0 .3.1.1 0 0 .1-.1.2zm4.9-2.8c-.1.1-.2 0-.3 0-.1-.1 0-.3.1-.3.1-.1.3 0 .3.1.1-.1 0 .1-.1.2zm11.2 23.5c-.1 0-.2-.1-.3-.2 0-.1.1-.2.2-.3.1 0 .2.1.3.2 0 .2-.1.3-.2.3zm-.7-5.6c-.1 0-.2-.1-.3-.2 0-.1.1-.2.2-.3.1 0 .2.1.3.2 0 .2-.1.3-.2.3zm-.8-5.6c-.1 0-.2-.1-.3-.2 0-.1.1-.2.2-.3.1 0 .2.1.3.2.1.1 0 .3-.2.3zm-.7-5.6c-.1 0-.2-.1-.3-.2 0-.1.1-.2.2-.3.1 0 .2.1.3.2 0 .1-.1.3-.2.3zm-.8-5.6c-.1 0-.2-.1-.3-.2 0-.1.1-.2.2-.3.1 0 .3.1.3.2s0 .3-.2.3zm-18 17c-.1 0-.1 0 0 0-.2-.1-.2-.3-.1-.4.1-.1.2-.1.3-.1.1.1.1.2 0 .3 0 .2-.1.2-.2.2zm3.6-4.6c-.1.1-.2.1-.3.1-.1-.1-.1-.2-.1-.3.1-.1.2-.1.3 0 .2 0 .2.1.1.2zm3.5-4.5c-.1.1-.2.1-.3 0-.1-.1-.1-.2 0-.3.1-.1.2-.1.3 0 0 .1.1.2 0 .3zm3.4-4.5c-.1.1-.2.1-.3 0-.1-.1-.1-.2-.1-.3.1-.1.2-.1.3-.1.2.2.2.3.1.4zm3.4-4.4H100.8c-.1-.1-.1-.2 0-.3.1-.1.2-.1.3 0 .1 0 .1.1 0 .3zm-24.9-.6c-.1 0-.2-.1-.3-.2 0-.1.1-.2.2-.3.1 0 .2.1.3.2.1.1 0 .3-.2.3zm5.7-.8c-.1 0-.2-.1-.3-.2 0-.1.1-.2.2-.3.1 0 .3.1.3.2 0 .2-.1.3-.2.3zm5.6-.7c-.1 0-.2-.1-.3-.2 0-.1.1-.2.2-.3.1 0 .2.1.3.2 0 .1-.1.3-.2.3zm5.6-.8c-.1 0-.2-.1-.3-.2 0-.1.1-.2.2-.3.1 0 .2.1.3.2 0 .2-.1.3-.2.3zm5.6-.7c-.1 0-.2-.1-.3-.2 0-.1.1-.2.2-.3.1 0 .2.1.3.2 0 .1-.1.3-.2.3zm13 26.5c-.2 0-.4-.1-.4-.4 0-.2.1-.4.4-.4.2 0 .4.1.4.4 0 .2-.2.4-.4.4zm-1.1-9.6c-.2 0-.4-.1-.4-.4s.1-.4.4-.4c.2 0 .4.1.4.4 0 .1-.2.3-.4.4zm-.9-9.7H109.4c-.1-.1-.2-.2-.2-.3 0-.2.2-.4.4-.4s.4.1.4.4l-.3.3zM76 265.6c-.1.2-.4.2-.6.1-.2-.1-.2-.4-.1-.6.1-.2.4-.2.6-.1.2.1.2.4.1.6zm6-7.6c-.1.2-.4.2-.6.1-.2-.1-.2-.4-.1-.6.1-.2.4-.2.6-.1.2.1.3.4.1.6zm6.1-7.6c-.1.2-.4.2-.6.1-.2-.1-.2-.4 0-.6.1-.2.4-.2.6 0 .1.1.1.3 0 .5zm6-7.6c-.1.2-.4.2-.6.1-.2-.1-.2-.4-.1-.6.1-.2.4-.2.6-.1.2.2.3.4.1.6zm6.1-7.6c-.1.2-.4.2-.6.1-.2-.1-.2-.4-.1-.6.1-.2.4-.2.6-.1.2.2.2.5.1.6zm6-7.5c-.1.2-.4.2-.6.1-.2-.1-.2-.4-.1-.6.1-.2.4-.2.6-.1.2.1.3.4.1.6zM56 230c-.2 0-.4-.1-.5-.4 0-.2.2-.4.4-.4s.4.1.4.4c0 .2-.1.3-.3.4zm9.6-1.1c-.2 0-.4-.1-.4-.4 0-.2.1-.4.4-.4s.4.1.4.4c0 .2-.2.4-.4.4zm9.6-1.1c-.2 0-.4-.1-.4-.4 0-.2.1-.4.4-.5.2 0 .4.2.4.4 0 .3-.2.5-.4.5zm9.7-1.1c-.2 0-.4-.1-.4-.4 0-.2.1-.4.4-.5.2 0 .4.1.4.3 0 .4-.2.6-.4.6zm9.6-1c-.2 0-.4-.1-.4-.4 0-.2.1-.4.4-.4.2 0 .4.1.4.4 0 .1-.2.3-.4.4zm24.2 15.4c-.2.1-.4 0-.5-.1-.1-.2 0-.4.1-.5.2-.1.4 0 .6.2.1.1 0 .3-.2.4zm-4.6-8.5c-.2.1-.4 0-.5-.1-.1-.2 0-.4.1-.5.2-.1.4 0 .5.2.1.1 0 .3-.1.4zM101 252.5c-.2-.1-.3-.3-.3-.5.1-.2.3-.3.5-.3.2.1.3.3.3.5s-.3.3-.5.3zm2.7-9.4c-.2-.1-.3-.3-.3-.5.1-.2.3-.3.5-.3.2.1.3.3.3.5 0 .3-.3.4-.5.3zm2.7-9.3c-.2-.1-.3-.3-.3-.5.1-.2.3-.3.5-.3.2.1.3.2.3.5s-.3.4-.5.3zm-39.7 14.4c-.2.1-.4 0-.6-.2-.1-.2 0-.4.2-.5.2-.1.4 0 .5.1.2.2.1.4-.1.6 0-.1 0-.1 0 0zm8.5-4.7c-.2.1-.4 0-.6-.2-.1-.2 0-.4.2-.5.2-.1.4 0 .5.1.2.2.1.4-.1.6zm8.5-4.7c-.2.1-.4 0-.5-.1-.1-.2-.1-.4.1-.6.2-.1.4-.1.6.1.1.2 0 .5-.2.6zm8.5-4.7c-.2.1-.4 0-.5-.2-.1-.2 0-.4.2-.5.2-.1.4 0 .5.1.1.2 0 .5-.2.6zm8.5-4.7c-.2.1-.4 0-.6-.2-.1-.2 0-.4.2-.6.2-.1.4 0 .5.2.2.2.1.5-.1.6zm-10.8-10c-.2-.1-.3-.3-.3-.5.1-.2.3-.3.5-.3.2.1.3.3.3.5 0 .3-.2.4-.5.3zm9.4 2.7c-.2-.1-.3-.3-.3-.5.1-.2.3-.3.5-.3.2.1.3.3.3.5-.1.2-.3.4-.5.3zm22.1 17.2c-.2.1-.4.1-.5-.1-.1-.2-.1-.4.1-.5.2-.1.4-.1.5.1.1.2 0 .4-.1.5zm-13.6 11.2c-.2-.1-.3-.3-.3-.5.1-.2.3-.3.5-.3s.3.2.3.5c-.1.2-.3.3-.5.3zm2.3-9.4c-.2-.1-.3-.3-.3-.5.1-.2.3-.3.5-.3s.3.2.3.5c-.1.2-.3.4-.5.3zm2.3-9.4c-.2-.1-.3-.3-.3-.5s.2-.3.5-.3c.2 0 .4.3.3.5-.1.2-.3.4-.5.3zm-44 22.9c-.2.1-.4 0-.5-.1-.1-.2 0-.4.2-.5.2-.1.4 0 .5.1.1.1 0 .4-.2.5zm8.3-5c-.2.1-.4.1-.6-.1-.1-.2-.1-.4.1-.5.2-.1.4-.1.6.1.1.1.1.4-.1.5zm8.2-5c-.2.1-.4.1-.6-.1-.1-.2-.1-.4.1-.5.2-.1.4-.1.5.1.3.1.2.3 0 .5zm8.3-5.1c-.2.1-.4.1-.5-.1-.1-.2-.1-.4.1-.5.2-.1.4-.1.5.1.1.2.1.4-.1.5zm8.2-5c-.2.1-.4.1-.5-.1v-.2c0-.1.1-.3.2-.4.2-.1.4-.1.5.1.1.2 0 .5-.2.6zm8.3-5c-.1 0-.2.1-.2 0h-.1c-.1 0-.2-.1-.2-.2-.1-.2-.1-.4.1-.5.1-.1.2-.1.4 0 .1 0 .1.1.2.2 0 .1 0 .4-.2.5zm-29-10.5c-.2-.1-.3-.3-.3-.5.1-.2.3-.3.5-.3s.3.2.3.5c-.1.2-.3.4-.5.3zm9.6 2.3H90c-.2 0-.4-.3-.3-.5 0-.2.2-.3.4-.3h.1c.1 0 .2.1.3.2.1.1.1.2.1.3l-.3.3zm9.1 2.3c-.2 0-.3-.2-.3-.5 0 0 0-.1.1-.1 0-.1.1-.1.1-.1.1-.1.2-.1.3 0 .2.1.3.3.3.5 0 .1-.3.2-.5.2zm16.4 12.6c-.2 0-.4-.1-.4-.3 0-.2.1-.4.3-.5.2 0 .4.1.5.3 0 .3-.2.5-.4.5zM91.7 258c-.1.2-.4.2-.6.1-.2-.1-.2-.4-.1-.6.1-.2.4-.2.6-.1.2.1.2.4.1.6zm5.7-7.8c-.1.2-.4.2-.6.1-.2-.1-.2-.4-.1-.6.1-.2.4-.2.6-.1.2.1.2.4.1.6zm5.7-7.8c-.1.2-.4.2-.6.1-.2-.1-.2-.4-.1-.5.1-.2.4-.2.6-.1.2 0 .2.3.1.5zm5.7-7.8c-.1.2-.4.2-.6.1-.2-.1-.2-.4-.1-.6.1-.2.4-.2.6-.1.2.2.2.4.1.6zm-42.6-.1c-.2 0-.4-.1-.5-.3 0-.2.1-.4.3-.4.2 0 .4.1.5.3.1.2 0 .4-.3.4zm9.6-1.5c-.2 0-.4-.1-.5-.3 0-.2.1-.4.3-.4.2 0 .4.1.5.3.1.2-.1.4-.3.4zm9.5-1.5c-.2 0-.4-.1-.5-.3 0-.2.1-.4.3-.4.2 0 .4.1.5.3.1.2 0 .4-.3.4zm9.6-1.4c-.2 0-.4-.1-.5-.3 0-.2.1-.4.3-.4.2 0 .4.1.5.3 0 .1-.1.3-.3.4zm9.5-1.5c-.2 0-.4-.1-.5-.3 0-.2.1-.4.3-.4.2 0 .4.1.4.3.2.1 0 .3-.2.4zm-15.8-12.9c-.2-.1-.2-.3-.1-.4.1-.2.3-.2.4-.1.2.1.2.3.1.4 0 .1-.2.2-.4.1zm6.6 3.2c-.1-.1-.2-.2-.1-.4.1-.1.2-.2.4-.2.1.1.2.2.1.4s-.3.2-.4.2zm26.5 21.2s-.1 0 0 0c-.1-.2 0-.4.1-.5.1 0 .2 0 .3.1l-.4.4zm-11.4 6.2c-.2-.1-.2-.3-.1-.4.1-.2.3-.2.4-.1.1.1.2.2.1.4-.1.1-.3.2-.4.1zm3.1-6.5c-.1-.1-.2-.2-.1-.4s.2-.2.4-.1c.1.1.2.2.1.4 0 .1-.2.1-.4.1zm-32.8 3.4c-.2.1-.3 0-.4-.2-.1-.2 0-.3.2-.4.1-.1.3 0 .4.2 0 .2-.1.3-.2.4zm6.8-2.4c-.2.1-.3 0-.4-.2-.1-.2 0-.3.2-.4.2-.1.3 0 .4.2.1.1 0 .3-.2.4zm6.9-2.4c-.2.1-.3 0-.4-.2-.1-.2 0-.3.2-.4.2-.1.3 0 .4.2.1.1 0 .3-.2.4zm6.9-2.4c-.2.1-.3 0-.4-.2-.1-.2 0-.3.2-.4.2-.1.3 0 .4.2.1.1 0 .3-.2.4 0-.1 0-.1 0 0zm6.9-2.5c-.2.1-.3 0-.4-.2-.1-.2 0-.3.2-.4.2-.1.3 0 .4.2 0 .2-.1.4-.2.4zm9.4 10.3c0-.1.1-.2.2-.2 0 .1-.1.2-.2.2zm.7-6.9c-.2 0-.3-.1-.3-.3 0-.2.1-.3.3-.3.2 0 .3.1.3.3 0 .2-.1.3-.3.3zm-26.6 17.2c-.1.1-.3.1-.4 0-.1-.1-.1-.3 0-.4.1-.1.3-.1.4 0 .1.1.1.2 0 .4zm5.4-4.9c-.1.1-.3.1-.4 0-.1-.1-.1-.3 0-.4.1-.1.3-.1.4 0 .1.1.1.3 0 .4zm5.4-4.8c-.1.1-.3.1-.4 0-.1-.1-.1-.3 0-.4.1-.1.3-.1.4 0 .2.1.2.2 0 .4zm5.5-4.9c-.1.1-.3.1-.4 0-.1-.1-.1-.3 0-.4.1-.1.3-.1.4 0 .1.1.1.3 0 .4zm5.4-4.8c-.1.1-.2.1-.3 0 0 0-.1 0-.1-.1-.1-.1-.1-.3 0-.4.1-.1.3-.1.4 0 .1.1.1.2.1.2 0 .1-.1.2-.1.3zm-31.4-6.8c-.2 0-.3-.1-.3-.3 0-.2.1-.3.3-.3.2 0 .3.2.3.3 0 .2-.1.3-.3.3zm7.3.4c-.2 0-.3-.2-.3-.3 0-.2.2-.3.3-.3.2 0 .3.2.3.3 0 .2-.2.3-.3.3zm7.3.4c-.2 0-.3-.1-.3-.3 0-.2.2-.3.3-.3.2 0 .3.1.3.3 0 .2-.2.3-.3.3zm7.2.4c-.2 0-.3-.1-.3-.3 0-.2.2-.3.3-.3.2 0 .3.1.3.3 0 .2-.1.3-.3.3zm18 9.5c-.1 0-.1-.1-.1-.2s.1-.1.2-.1.1.1.1.2c-.1.1-.2.2-.2.1zm-17.1 6c-.1.1-.2 0-.2 0-.1-.1 0-.2 0-.2h.2c.1 0 .1.1 0 .2zm3.4-2.2h-.2v-.2c.1-.1.2 0 .2 0 .1.1.1.2 0 .2zm3.3-2.1c-.1.1-.2 0-.2 0 0-.1 0-.2.1-.2s.2 0 .2.1c0-.1 0 0-.1.1zm3.4-2.1h-.2c0-.1 0-.2.1-.2s.2 0 .2.1c0-.1 0 0-.1.1zm3.3-2.2c-.1 0-.2 0-.2-.1s0-.2.1-.2c.1-.1.2 0 .2 0 0 .2 0 .3-.1.3zm-16.4-7.9c-.1 0-.1-.1-.1-.2s.1-.1.2-.1.2.1.1.2c0 .1-.1.1-.2.1zm3.9.9c-.1 0-.1-.1-.1-.2s.1-.1.2-.1.2.1.1.2c-.1 0-.1.1-.2.1zm3.8.8c-.1 0-.1-.1-.1-.2s.1-.1.2-.1.1.1.1.2-.1.1-.2.1c.1 0 0 0 0 0zm4.9 16c-.1.1-.2.1-.2 0-.1-.1-.1-.2 0-.2.1-.1.2-.1.2 0 .1 0 .1.1 0 .2zm2.3-3.3c-.1.1-.2.1-.2 0-.1 0-.1-.1-.1-.2.1-.1.2-.1.2 0 .1 0 .2.1.1.2zm2.3-3.3c-.1.1-.2.1-.2 0-.1-.1-.1-.2 0-.2.1-.1.2-.1.2 0v.2zm-15.3-2.9c-.1 0-.2 0-.2-.1s0-.2.1-.2.2 0 .2.1c.1.1 0 .2-.1.2zm4-.7c-.1 0-.2 0-.2-.1s0-.2.1-.2.2 0 .2.1 0 .2-.1.2zm3.9-.7c-.1 0-.2 0-.2-.1s0-.2.1-.2.2 0 .2.1 0 .2-.1.2zm3.9-.7c-.1 0-.2 0-.2-.1s.1-.2.1-.2c.1 0 .2 0 .2.1s0 .2-.1.2zm-18.5 11.3c-.1 0-.3-.1-.3-.2s.1-.3.2-.3.3.1.3.2-.1.2-.2.3zm6.4-1.2c-.1 0-.3-.1-.3-.2s.1-.3.2-.3.3.1.3.2c.1.1 0 .3-.2.3zm6.5-1.2c-.1 0-.3-.1-.3-.2s.1-.3.2-.3.3.1.3.2c.1.1 0 .3-.2.3zm6.5-1.2c-.1 0-.3-.1-.3-.2s.1-.3.2-.3.3.1.3.2c0 .2-.1.3-.2.3zm-15.9-9.7c-.1 0-.2-.2-.2-.3 0-.1.2-.2.3-.2.1 0 .2.2.2.3 0 .1-.2.2-.3.2zm6.6 1.3c-.1 0-.1.1-.2 0-.1 0-.2-.2-.2-.3 0-.1.1-.1.1-.2.1 0 .1-.1.2 0 .1 0 .2.2.2.3 0 .1 0 .2-.1.2zm6.2 1.4c-.1 0-.2-.1-.2-.2v-.1c0-.1.2-.2.3-.2.1 0 .2.2.2.3 0 .2-.1.3-.3.2zm6.5 1.4c-.2 0-.2-.2-.2-.3 0-.1.2-.2.3-.2.2 0 .2.2.2.3 0 .2-.2.2-.3.2z",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }